<template>
    <div class="lm-border pa-3" >
        <div class="v-flex step-title ">
            <div class=" primary--text" style="padding-top: 3px;">
                <span>{{ $t('invoice.sum.title') }}</span>
                <span>
                    {{ toMoney (invoice.item.amount.net) }}
                </span>
            </div>

            <inc-invoice-stamp-menu
                :data    = "invoice"
                @stamped = "onStamped"
                @mail    = "onSendStampMail"
                @reset   = "onReset"
                style="margin-bottom: 3px;"
            />
        </div>

        <!-- Invoice dates -->
        <p-inc-invoice-dates
            :data       = "invoice"
            :collective = "true"
        />
        <!-- Invoice dates -->

        <!-- Invoice number and invoice date -->
        <v-row class="no-frame mt-1" >
            <v-col class="no-frame pr-2">
                <v-text-field
                    v-model        = "invoice.invoicenumber"
                    :rules         = "[requiredOnTerminationRule]"
                    :label         = "$t('invoice.invoicenumber')"
                    background-color = "field-group-background-blue"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    class="label--active"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-date-picker
                    v-model = "invoice.invoiceDate"
                    label   = "invoice.invoiceDate"
                    background-color="field-group-background-blue"
                    :time   = "false"
                />
            </v-col>
        </v-row>

        <v-row
            v-if="showCosts"
            class = "no-frame mt-0"
        >
            <v-col
                class  = "no-frame col-6 pr-1 pl-0 primary--text"
                style="font-size: 12px; text-align: center"
            >
                Urspungsrechnung
            </v-col>
            <v-col
                class="no-frame col-6 pl-2 primary--text"
                style="font-size: 12px; text-align: center"
            >
                Korrigierte Rechnung
            </v-col>
        </v-row>
        <v-row dense class="no-frame">
            <v-col class="no-frame pr-2">
                <div class="lm-border pl-2 pr-2 pt-1 pb-1">
                    <f-read-only-field
                        :label="$t('invoice.cost.net')"
                        :value="toMoney (invoice.item.calculated.net)"
                        :align-right = "true"
                        collective
                        dense
                    />
                    <f-read-only-field
                        v-if         = "showCosts"
                        class        = "mt-2"
                        :label       = "$t('invoice.cost.material')"
                        :value       = "toMoney (invoice.item.calculated.costMaterial)"
                        :align-right = "true"
                        collective
                        dense
                    />
                    <f-read-only-field
                        v-if         = "showCosts"
                        class        ="mt-2"
                        :label       ="$t('invoice.cost.wage')"
                        :value       ="toMoney (invoice.item.calculated.costWage)"
                        :align-right = "true"
                        collective
                        dense
                    />
                </div>
            </v-col>

            <v-col class="no-frame pl-2">
                <div v-if="showCosts" class="lm-border pl-2 pr-2 pt-1 pb-1">
                    <f-read-only-field
                        :label="$t('invoice.cost.invoice')"
                        :value="toMoney (invoice.item.correction.net)"
                        :align-right = "true"
                        collective
                        dense
                    />
                    <f-read-only-field
                        class="mt-2"
                        :label="$t('invoice.cost.material')"
                        :value="toMoney (invoice.item.correction.costMaterial)"
                        :align-right = "true"
                        collective
                        dense
                    />
                    <f-read-only-field
                        class="mt-2"
                        :label="$t('invoice.cost.wage')"
                        :value="toMoney (invoice.item.correction.costWage)"
                        :align-right = "true"
                        collective
                        dense
                    />
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core                from "@/modules/core/service/Core";
import FDatePicker         from "@/modules/core/components/utils/FDatePicker.vue";
import FReadOnlyField      from "@/modules/core/components/utils/FReadOnlyField.vue";
import IncInvoiceStampMenu from "@/modules/inc/steps/components/invoice/private/PIncInvoiceStampMenu.vue";
import PIncInvoiceDates    from "@/modules/inc/steps/components/invoice/private/PIncInvoiceDates.vue";

export default {
    name: "PInvoiceSum",

    components: {
        FDatePicker,
        PIncInvoiceDates,
        IncInvoiceStampMenu,
        FReadOnlyField
    },

    props: {
        invoice: {

        },

        status: {

        },

        showCosts: {
            required: true,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        calculation: {
            required: false,
            type    : Function,
            default : function () {
                return null;
            }
        },

        validate: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
    },

    data: () => ({
        error: false
    }),

    mounted() {
        this.calculate();
    },

    watch: {
        invoice () {
            this.calculate();
        }
    },

    methods: {
        calculate () {
            if (!this.invoice) {
                return;
            }

            const amount = {
                net         : 0,
                costMaterial: 0,
                costWage    : 0
            };

            const correction = {
                net         : 0,
                costMaterial: 0,
                costWage    : 0
            };

            this.invoice.collection.forEach(i => {
                amount.net              += i.item_1.amount.net;
                amount.costMaterial     += i.item_1.amount.costMaterial;
                amount.costWage         += i.item_1.amount.costWage;
                correction.net          += i.item_1.correction.net;
                correction.costMaterial += i.item_1.correction.costMaterial;
                correction.costWage     += i.item_1.correction.costWage;
            });

            this.invoice.item.calculated.net = amount.net;
            this.invoice.item.calculated.costMaterial = amount.costMaterial;
            this.invoice.item.calculated.costWage = amount.costWage;
            this.invoice.item.correction.net = correction.net;
            this.invoice.item.correction.costMaterial = correction.costMaterial;
            this.invoice.item.correction.costWage = correction.costWage;

            if (this.validate && this.calculation && !this.showCosts) {
                const value  = this.calculation();
                this.error = value && value !== amount.net;
            }
        },

        onSendStampMail (documents) {
            this.$emit("stampmail", documents);
        },

        /**
         * The selected document was stamped.
         */
        onStamped () {
            this.invoice.verficationDate = Core.format.date.toJson(Core.format.today());
            this.$emit("stamped");
        },

        onReset () {
            this.invoice.verficationDate = null;
            this.invoice.sendDate        = null;
            this.$emit("reset");
        },

        toMoney (value) {
            return Core.format.money(value);
        },

        requiredOnTerminationRule (value)  {
            return Core.rule.requiredOnTermination(value, this.status);
        },
    }
}
</script>

<style scoped>


</style>
